<template>
  <div>
    <section id="devicevideosection">
      <video style="width:100%" id="devicevideo" ref="deviceVideo"></video>
      <img class="overlay" src="@/assets/img/bp_device.png" v-if="device.id == 'sphygmomanometer-NIBP036640'" />
      <img class="overlay" src="@/assets/img/spo2_device.png" v-if="device.id == 'pulse-oximeter-SpO2087865'" />
      <img ref="preview" style="display:none" />
      <p ref="result" style="display:none"></p>
    </section>

    <div class="col-12 floating text-center" style="inset-inline-end:inherit;display:none">
      <n-button type="info" social icon round size="lg" @click.native="takeDeviceSnapshot()">
        <i class="fa fa-camera-retro"></i>
      </n-button>
      <n-button type="info" social icon round size="lg" @click.native="ocr(device.scanType)">
        <i class="fa fa-search"></i>
      </n-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ocr as ocrUtil } from "../../../utils/device.js";
import $ from "jquery";
import { create, all } from "mathjs";
const math = create(all, {});

export default {
  name: "scan-vital",

  async mounted() {
    //Clear previosuly scanned vital data
    this.$store.commit("setState", {
      stateName: "scannedDevices",
      stateValue: [],
    });

    try {
      let response = await this.$store.dispatch(
        "getConfigurationByEndpointId",
        {
          endpointId: this.user.endpoint._id || this.user.endpoint,
          type: "deviceProfile",
        }
      );
      if (response && response.value) {
        this.deviceProfile = response.value;
      }
      this.$store.commit("setState", {
        stateName: "deviceProfile",
        stateValue: this.deviceProfile,
      });
    } catch (e) {
      console.log(e);
    }

    this.startLoop();
  },

  destroyed() {
    clearInterval(this.intervalHandle);
  },

  data() {
    return {
      imageBase64Data: null,
      intervalHandle: null,
      deviceProfile: [],
    };
  },
  props: ["doNotRouteBack"],
  computed: {
    ...mapState({
      device: (state) => state.deviceToScan,
    }),
    overlayImage() {
      console.log(require("../../../assets/img/bp_device.png"));
      return require("../../../assets/img/bp_device.png");
    },
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
  },

  methods: {
    async startLoop() {
      let that = this;
      let stream = null;
      var constraints = {
        audio: false,
        video: {
          facingMode: "environment",
          width: 640,
          height: 480,
        },
      };
      try {
        stream = await navigator.mediaDevices.getUserMedia(constraints);
        that.$refs.deviceVideo.srcObject = stream;
        that.$refs.deviceVideo.onloadedmetadata = function (e) {
          that.$refs.deviceVideo.play();

          let limit = 60;
          let counter = 0;
          that.intervalHandle = setInterval(() => {
            if (counter > limit) {
              clearInterval(that.intervalHandle);
              swal.fire({
                type: "error",
                title: that.$t("message.Oops, vitals unrecognized"),
                text: that.$t("message.Oops, vitals unrecognized"),
              });
            }

            counter += 1;
            that.takeDeviceSnapshot();
            that.ocr(that.device.scanType);
          }, 1000);
        };
      } catch (err) {
        console.log(err.name + ": " + err.message);
      }
    },
    takeDeviceSnapshot() {
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      canvas.width = this.$refs.deviceVideo.videoWidth;
      canvas.height = this.$refs.deviceVideo.videoHeight;
      context.drawImage(
        this.$refs.deviceVideo,
        0,
        0,
        canvas.width,
        canvas.height
      );
      this.imageBase64Data = canvas.toDataURL("image/png");
      this.$refs.preview.src = this.imageBase64Data;
    },
    handleUnitConversion(unitMetadata, reading) {
      //reading.unit = reading.unit.toLowerCase();
      let unit =
        unitMetadata && unitMetadata.primary
          ? unitMetadata.primary
          : unitMetadata;
      if (reading.unit == unit) {
        return reading;
      }

      if (isNaN(reading.value)) {
        return reading;
      }

      var conversionStr = unitMetadata.secondary[reading.unit];

      if (!conversionStr) {
        return reading;
      }

      var conversionFunc = math.eval("f(x) = " + conversionStr);
      var convertedVal = conversionFunc(Number(reading.value));
      convertedVal = math.format(convertedVal, {
        notation: "fixed",
        precision: 2,
      });
      reading.value = convertedVal;
      reading.unit = unit;

      return reading;
    },
    async ocr(ocrType) {
      var that = this;
      try {
        let response = await ocrUtil(that.device, that.imageBase64Data);
        if (response && response.data) {
          response.data.forEach((measuredVital) => {
            if (measuredVital && measuredVital.value) {
              that.device.vitals.forEach((vital, index) => {
                if (vital.identifier == measuredVital.type) {
                  let convertedVital = that.handleUnitConversion(vital.unit, {
                    name: measuredVital.type,
                    value: Number(measuredVital.value),
                    unit: measuredVital.unit,
                  });

                  that.device.vitals[index].value = convertedVital.value;
                  that.device.vitals[index].unit = convertedVital.unit;
                  return;
                }
              });
            }
          });
          clearInterval(that.intervalHandle);
          that.askVitalConfrim();
        } else {
          console.log("Error", err);
        }
      } catch (err) {
        console.log("Error", err);
      }
    },
    async askVitalConfrim() {
      //Generation html nodes with vitals info to display on swal
      let that = this;
      let vitalText = "";
      that.device.vitals.forEach((vital) => {
        vitalText =
          vitalText +
          '<div class="col-12">' +
          vital.displayName[this.$i18n.locale] +
          ": " +
          vital.value +
          " " +
          vital.unit +
          "</div>";
      });

      swal
        .fire({
          title: this.$t("message.Result"),
          html:
            '<div class="row"> <div class="col-4"> <img src="' +
            that.imageBase64Data +
            '"> </div> <div class="col-8"> <div class="row">' +
            vitalText +
            "</div> </div> </div>",
          confirmButtonText: this.$t("message.Confirm"),
          cancelButtonText: this.$t("message.Retry"),
          showCancelButton: true,
          allowOutsideClick: false,
        })
        .then((confirmed) => {
          if (confirmed && confirmed.value) {
            //Populate vitals to device profile and go to vitals page
            let scannedDevices = [];
            that.deviceProfile.forEach((dp) => {
              if (dp.identifier == that.device.identifier) {
                scannedDevices.push(that.device);
                that.$store.commit("setState", {
                  stateName: "scannedDevices",
                  stateValue: scannedDevices,
                });
              }
            });

            setTimeout(() => {
              $("html, body").animate(
                {
                  scrollTop: $("#" + that.device.identifier).offset().top,
                },
                2000
              );
            }, 1000);

            if (that.doNotRouteBack) {
              that.$emit("confirmed");
            } else {
              that.$router.back();
            }
          } else {
            that.startLoop();
          }
        });
    },
  },
};
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 3%;
  left: 2%;
  width: 96%;
  /* height: 100%; */
}
.overlay img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  z-index: 2;
}
</style>
